(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-why-shop-here"] && !Shopify.designMode) return;
  try {
    
(function () {
  var ROOT_ID = 'bse-why-shop-here';

  function push(payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    } catch (e) { /* analytics must never break the page */ }
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.bse-w__reveal');
    if (!items.length) return;

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduced) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });

    Array.prototype.forEach.call(items, function (el, i) {
      el.style.transitionDelay = (i * 90) + 'ms';
      observer.observe(el);
    });
  }

  function initVideos(root) {
    var cards = root.querySelectorAll('.bse-w__video-card');
    Array.prototype.forEach.call(cards, function (card) {
      var overlay = card.querySelector('.bse-w__video-play');
      var button  = card.querySelector('button.bse-w__video-play-btn');
      var video   = card.querySelector('video');
      var iframe  = card.querySelector('iframe');
      var caption = card.querySelector('.bse-w__video-caption p');

      // No real media yet (placeholder card) or no interactive control: leave the
      // overlay in place as pure decoration.
      if (!overlay || !button || (!video && !iframe)) return;

      button.addEventListener('click', function () {
        overlay.hidden = true;

        if (video) {
          video.controls = true;
          video.setAttribute('playsinline', '');
          var played = video.play();
          if (played && typeof played.catch === 'function') {
            // Autoplay policies can reject an unmuted play(); the native controls
            // stay available either way, so just restore the overlay.
            played.catch(function () { overlay.hidden = false; });
          }
        } else if (iframe) {
          // Hosted embeds keep their own player chrome. Handing focus to the frame
          // is the most we can do without an iframe player API.
          iframe.focus();
        }

        push({
          event: 'video_play',
          module: 'why_shop_here',
          video_title: caption ? caption.textContent.trim() : ''
        });
      });
    });
  }

  function initCtaTracking(root) {
    root.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('[data-bse-cta]') : null;
      if (!link || !root.contains(link)) return;
      push({
        event: 'cta_click',
        module: 'why_shop_here',
        cta_id: link.getAttribute('data-bse-cta'),
        cta_label: link.textContent.trim()
      });
    });
  }

  function init() {
    var root = document.getElementById(ROOT_ID);
    if (!root || root.dataset.bseWInit === '1') return;
    root.dataset.bseWInit = '1';

    initReveal(root);
    initVideos(root);
    initCtaTracking(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run after a section reload so reveal and video wiring survive.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('#' + ROOT_ID) : null;
    if (!root) return;
    root.dataset.bseWInit = '';
    init();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-slider-v2"] && !Shopify.designMode) return;
  try {
    

(function () {
  class BseSlider {
    constructor(el) {
      this.el = el;
      this.slides = Array.from(el.querySelectorAll('.bse-slider__slide'));
      this.dots   = Array.from(el.querySelectorAll('.bse-slider__dot'));
      this.track  = el.querySelector('.bse-slider__track');

      this.current        = 0;
      this.total          = this.slides.length;
      this.isPaused       = false;
      this.autoplayTimer  = null;
      this.reducedMotion  = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoplay       = el.dataset.autoplay === 'true';
      this.autoplaySpeed  = parseInt(el.dataset.autoplaySpeed, 10) || 5500;
      this.touchStartX    = 0;
      this.touchStartY    = 0;

      if (this.total < 1) return;

      this._goTo(0, false);
      this._bindArrows();
      this._bindDots();
      this._bindPlayPause();
      this._bindKeyboard();
      this._bindTouch();
      this._bindVisibility();

      if (this.autoplay && this.total > 1 && !this.reducedMotion) {
        this._startAutoplay();
      }
    }

    // ── Core ──────────────────────────────────────────────
    _goTo(index, restartTimer) {
      if (restartTimer === undefined) restartTimer = true;
      const next = ((index % this.total) + this.total) % this.total;

      // Update slides
      for (let i = 0; i < this.slides.length; i++) {
        const slide   = this.slides[i];
        const active  = i === next;
        slide.classList.toggle('bse-slider__slide--active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      }

      // Update dots
      for (let i = 0; i < this.dots.length; i++) {
        const dot    = this.dots[i];
        const active = i === next;
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        const progress = dot.querySelector('.bse-slider__dot-progress');
        if (progress) {
          // Force reflow to restart CSS animation
          progress.style.animation = 'none';
          void progress.offsetWidth;
          if (active && this.autoplay && !this.isPaused && !this.reducedMotion) {
            progress.style.animation = '';
          }
        }
      }

      if (this.track) {
        this.track.setAttribute('aria-live', this.isPaused ? 'polite' : 'off');
      }

      this.current = next;

      if (restartTimer) this._restartAutoplay();
    }

    _next() { this._goTo(this.current + 1); }
    _prev() { this._goTo(this.current - 1); }

    // ── Autoplay ─────────────────────────────────────────
    _startAutoplay() {
      if (this.total < 2) return;
      this.autoplayTimer = setInterval(() => { this._next(); }, this.autoplaySpeed);
    }

    _stopAutoplay() {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }

    _restartAutoplay() {
      if (!this.autoplay || this.isPaused) return;
      this._stopAutoplay();
      this._startAutoplay();
    }

    // ── Event Bindings ───────────────────────────────────
    _bindArrows() {
      const prev = this.el.querySelector('.bse-slider__arrow--prev');
      const next = this.el.querySelector('.bse-slider__arrow--next');
      if (prev) prev.addEventListener('click', () => this._prev());
      if (next) next.addEventListener('click', () => this._next());
    }

    _bindDots() {
      for (const dot of this.dots) {
        dot.addEventListener('click', () => {
          this._goTo(parseInt(dot.dataset.index, 10));
        });
      }
    }

    _bindPlayPause() {
      const btn = this.el.querySelector('.bse-slider__play-pause');
      if (!btn) return;

      btn.addEventListener('click', () => {
        this.isPaused = !this.isPaused;
        btn.setAttribute('aria-pressed', this.isPaused ? 'true' : 'false');
        btn.setAttribute('aria-label', this.isPaused ? 'Play slideshow' : 'Pause slideshow');

        const pauseIcon = btn.querySelector('.bse-slider__icon-pause');
        const playIcon  = btn.querySelector('.bse-slider__icon-play');
        if (pauseIcon) pauseIcon.style.display = this.isPaused ? 'none' : '';
        if (playIcon)  playIcon.style.display  = this.isPaused ? ''     : 'none';

        if (this.isPaused) {
          this._stopAutoplay();
          // Freeze progress bars at current position
          for (const progress of this.el.querySelectorAll('.bse-slider__dot-progress')) {
            const pxWidth   = parseFloat(getComputedStyle(progress).width);
            const parentPx  = progress.parentElement.offsetWidth || 1;
            const pct       = (pxWidth / parentPx) * 100;
            progress.style.animation = 'none';
            progress.style.width = pct + '%';
          }
        } else {
          this._goTo(this.current, false);
          this._startAutoplay();
        }
      });
    }

    _bindKeyboard() {
      this.el.setAttribute('tabindex', '0');
      this.el.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this._prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this._next(); }
      });
    }

    _bindTouch() {
      this.el.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
        this.touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });

      this.el.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].screenX - this.touchStartX;
        const dy = e.changedTouches[0].screenY - this.touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? this._next() : this._prev();
        }
      }, { passive: true });

      this.el.addEventListener('mouseenter', () => { if (!this.isPaused) this._stopAutoplay(); });
      this.el.addEventListener('mouseleave', () => { if (!this.isPaused) this._restartAutoplay(); });
    }

    _bindVisibility() {
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this._stopAutoplay();
        } else if (!this.isPaused) {
          this._restartAutoplay();
        }
      });
    }
  }

  // ── Init all sliders on the page ───────────────────────
  function initSliders() {
    for (const el of document.querySelectorAll('.bse-slider:not([data-bse-init])')) {
      el.setAttribute('data-bse-init', 'true');
      new BseSlider(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  // Re-init after Shopify section re-renders in the editor
  document.addEventListener('shopify:section:load', initSliders);
})();


  } catch(e) { console.error(e); }
})();
})();
